import React from "react";

import {
  Typography,
  List,
  ListItem,
  Link,
  ListItemText,
  ListItemIcon,
  useTheme,
} from "@mui/material";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";

const PLACES = [
  "P1: Old Oak South",
  "P2: Old Oak North",
  "P3: Grand Union Canal",
  "P4: Park Royal West",
  "P5: Old Oak Park Royal",
  "P6: Park Royal Centre",
  "P7: North Acton and Acton Wells",
  "P8: Old Oak Lane and Old Oak Common Lane",
  "P9: Channel Gate",
  "P10: Scrubs Lane",
  "P11: Willesden Junction",
  "P12: Wormwood Scrubs",
];
const CONSERVATION = [
  "Old Oak Lane (located on Old Oak Lane north of the Grand Union Canal)",
  "Cumberland Park Factory (located on Scrubs Lane north of the Grand Union Canal)",
  "Grand Union Canal (located east of Old Oak Lane)",
  "Canalside (located west of Old Oak Lane)",
];
export const PlacesLongDescription = () => {
  const theme = useTheme();
  return (
    <>
      <Typography variant="body1">
        The Local Plan provides policies for each of our 12 places that exhibit
        local distinctiveness:
      </Typography>
      <List dense>
        {PLACES.map((place) => (
          <ListItem key={place}>
            <ListItemIcon sx={{ color: theme.palette.primary.main }}>
              <LabelImportantIcon />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ variant: "body1" }}>
              {place}
            </ListItemText>
          </ListItem>
        ))}
      </List>
    </>
  );
};

export const ConservationAreasLongDescription = () => {
  const theme = useTheme();
  return (
    <>
      <Typography variant="body1">
        There are currently four{" "}
        <Link
          target="_blank"
          rel="noreferrer"
          href="https://www.london.gov.uk/about-us/organisations-we-work/old-oak-and-park-royal-development-corporation-opdc/planning/heritage-policies/conservation-areas-and-areas-local-character"
          underline="hover"
        >
          conservation areas
        </Link>{" "}
        comprising:
      </Typography>
      <List dense>
        {CONSERVATION.map((conservation) => (
          <ListItem key={conservation}>
            <ListItemIcon sx={{ color: theme.palette.primary.main }}>
              <LabelImportantIcon />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ variant: "body1" }}>
              {conservation}
            </ListItemText>
          </ListItem>
        ))}
      </List>
    </>
  );
};

export const HeritageLongDescription = () => (
  <>
    <Typography variant="body1" paragraph>
      We have one Statutory Listed Asset, the Grade II Listed Brent Viaduct.{" "}
      <Link
        target="_blank"
        rel="noreferrer"
        href="https://www.london.gov.uk/about-us/organisations-we-work/old-oak-and-park-royal-development-corporation-opdc/planning/heritage-policies/statutory-listed-assets"
        underline="hover"
      >
        Click here to find out more.
      </Link>
    </Typography>
    <Typography variant="body1" paragraph>
      OPDC's Local Heritage Listings were adopted on 30 January 2020 and provide
      information for the 64 non-designated heritage assets.{" "}
      <Link
        target="_blank"
        rel="noreferrer"
        href="https://www.london.gov.uk/about-us/organisations-we-work/old-oak-and-park-royal-development-corporation-opdc/planning/heritage-policies/opdc-local-heritage-listings"
        underline="hover"
      >
        Click here to find out more.
      </Link>
    </Typography>
  </>
);
export const Article4LongDescription = () => (
  <Typography variant="body1" paragraph>
    The 2017 Article 4 Direction came into effect on 22 September 2017. This
    removes permitted development rights for changes of use from offices (use
    class B1) and storage and distribution uses (use class B8) to residential
    (use class C3). For the purposes of the B1 office uses (now reclassified as
    Class E(g)(i) uses), please refer to the 2022 Article 4 Direction on{" "}
    <Link
      target="_blank"
      rel="noreferrer"
      href="https://www.london.gov.uk/about-us/organisations-we-work/old-oak-and-park-royal-development-corporation-opdc/planning/opdc-planning-applications/article-4-directions"
      underline="hover"
    >
      OPDC's webpages
    </Link>
  </Typography>
);
export const NeighbourhoodAreasDescription = () => (
  <Typography variant="body1" paragraph>
    These are the Neighbourhood Areas within the OPDC area. You can find out
    more{" "}
    <Link
      target="_blank"
      rel="noreferrer"
      href="https://www.london.gov.uk/about-us/organisations-we-work/old-oak-and-park-royal-development-corporation-opdc/planning/planning-policy-0/neighbourhood-planning"
      underline="hover"
    >
      here
    </Link>
    .
  </Typography>
);
